import React from 'react';
import LazyLoad from 'react-lazyload';
import { useStyles } from './styles';
import { Box, Container, Typography } from '@mui/material';
import Image from 'next/image';
import CustomButton from 'components/CustomButton';
import NextLink from 'next/link';

export default function BookDemoMobile() {
  const classes = useStyles();

  return (
    <LazyLoad offset={100}>
      <Box bgcolor="#EEEEEE" py={4}>
        <Container>
          <Box className={classes.mainContentBox} py={6}>
            <Box py={3}>
              <Typography className={classes.title} component="h2">
                <b>Book a demo for your institution</b>
              </Typography>
            </Box>

            <Box className={classes.mainFeaturesBox} mb={4}>
              <Box textAlign="center">
                <Image
                  src="/images/user-friendly-icon.png"
                  alt="user friendly icon"
                  loading="lazy"
                  width={54}
                  height={54}
                />

                <Typography className={classes.titleFeatures}>
                  User-friendly <br /> Interface
                </Typography>

                <Typography className={classes.subTitleFeatures}>
                  Easy to understand and <br /> even easier to use.
                </Typography>
              </Box>

              <Box textAlign="center">
                <Image
                  src="/images/star-black-icon.png"
                  alt="star icon"
                  loading="lazy"
                  width={67}
                  height={59}
                />

                <Typography className={classes.titleFeatures}>
                  Priority Chat <br /> Support
                </Typography>

                <Typography className={classes.subTitleFeatures}>
                  In case you need help, <br /> reach out to our online <br /> priority chat
                  support.
                </Typography>
              </Box>
            </Box>

            <Box className={classes.mainFeaturesBox} mb={4}>
              <Box textAlign="center">
                <Image
                  src="/images/online-platform-icon.webp"
                  alt="online platform icon"
                  loading="lazy"
                  width={67}
                  height={64}
                />

                <Typography className={classes.titleFeatures}>Online platform</Typography>

                <Typography className={classes.subTitleFeatures}>
                  Access creations <br /> at any time and <br /> from anywhere.
                </Typography>
              </Box>

              <Box textAlign="center">
                <Image
                  src="/images/pre-made-resources-black-icon.png"
                  alt="pre made resources icon"
                  loading="lazy"
                  width={72}
                  height={71}
                />

                <Typography className={classes.titleFeatures}>
                  Pre-made <br /> Resources
                </Typography>

                <Typography className={classes.subTitleFeatures}>
                  Start editing one of our <br /> templates. Just customize <br /> colors, text and
                  more.
                </Typography>
              </Box>
            </Box>

            <Box className={classes.mainFeaturesBox} mb={4}>
              <Box textAlign="center">
                <Image
                  src="/images/on-demand-illustration-black-icon.png"
                  alt="on demand icon"
                  loading="lazy"
                  width={62}
                  height={76}
                />

                <Typography className={classes.titleFeatures}>On-demand illustrations</Typography>

                <Typography className={classes.subTitleFeatures}>
                  Couldn't find what
                  <br /> you need? We will <br /> design it for you.
                </Typography>
              </Box>

              <Box textAlign="center">
                <Image
                  src="/images/drag-drop-icon.webp"
                  alt="drag drop icon"
                  loading="lazy"
                  width={65}
                  height={71}
                />

                <Typography className={classes.titleFeatures}>Drag and Drop</Typography>

                <Typography className={classes.subTitleFeatures}>
                  Easily select <br /> and manage <br /> illustrations, text and templates.
                </Typography>
              </Box>
            </Box>

            <Box className={classes.mainFeaturesBox}>
              <Box textAlign="center">
                <Image
                  src="/images/digital-illustration-black-icon.png"
                  alt="digital illustration icon"
                  loading="lazy"
                  width={75}
                  height={75}
                />

                <Typography className={classes.titleFeatures}>
                  Scientifically-accurate <br /> illustrations
                </Typography>

                <Typography className={classes.subTitleFeatures}>
                  Represent science concepts <br /> graphically with maximum <br /> accuracy.
                </Typography>
              </Box>
            </Box>

            <Box display="flex" justifyContent="center" py={3}>
              <NextLink href={`/institutions/book-a-demo`} passHref={true}>
                <CustomButton>Book a Demo</CustomButton>
              </NextLink>
            </Box>
          </Box>
        </Container>
      </Box>
    </LazyLoad>
  );
}
